import { ref, computed } from 'vue'

export function useExpansionState() {
  const expandedActivities = ref(new Set())
  const expandedSubtasks = ref(new Set())

  const isActivityExpanded = (activityId) => {
    return expandedActivities.value.has(activityId.toString())
  }

  const isSubtaskExpanded = (activityId) => {
    return expandedSubtasks.value.has(activityId.toString())
  }

  const toggleActivityExpansion = (activityId) => {
    const id = activityId.toString()
    if (expandedActivities.value.has(id)) {
      expandedActivities.value.delete(id)
    } else {
      expandedActivities.value.add(id)
    }
  }

  const toggleSubtaskExpansion = (activityId) => {
    const id = activityId.toString()
    if (expandedSubtasks.value.has(id)) {
      expandedSubtasks.value.delete(id)
    } else {
      expandedSubtasks.value.add(id)
    }
  }

  const setActivityExpanded = (activityId, expanded) => {
    const id = activityId.toString()
    if (expanded) {
      expandedActivities.value.add(id)
    } else {
      expandedActivities.value.delete(id)
    }
  }

  const setSubtaskExpanded = (activityId, expanded) => {
    const id = activityId.toString()
    if (expanded) {
      expandedSubtasks.value.add(id)
    } else {
      expandedSubtasks.value.delete(id)
    }
  }

  const clearAll = () => {
    expandedActivities.value.clear()
    expandedSubtasks.value.clear()
  }

  return {
    expandedActivities: computed(() => expandedActivities.value),
    expandedSubtasks: computed(() => expandedSubtasks.value),
    isActivityExpanded,
    isSubtaskExpanded,
    toggleActivityExpansion,
    toggleSubtaskExpansion,
    setActivityExpanded,
    setSubtaskExpanded,
    clearAll
  }
}
